export default {"src":"/_next/static/media/YoutubeInverted.cf94d881.svg","height":33,"width":33,"blurWidth":0,"blurHeight":0};